import { render, staticRenderFns } from "./TypesPage.vue?vue&type=template&id=79244146&scoped=true"
import script from "./TypesPage.vue?vue&type=script&lang=js"
export * from "./TypesPage.vue?vue&type=script&lang=js"
import style0 from "./TypesPage.vue?vue&type=style&index=0&id=79244146&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79244146",
  null
  
)

export default component.exports